/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigResponse } from '../../models/config-response';

export interface GetConfigs1$Params {
}

export function getConfigs1(http: HttpClient, rootUrl: string, params?: GetConfigs1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConfigResponse>>> {
  const rb = new RequestBuilder(rootUrl, getConfigs1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ConfigResponse>>;
    })
  );
}

getConfigs1.PATH = '/configs/all';
